<template>
  <div class="text-center mb-5">
    <img :src="imagem.src" :alt="imagem.alt" class="img-fluid"/>
  </div>
</template>

<script>
import ImageUtils from '@/core/utils/image-utils'

export default {
  name: 'TopicoImagem',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imagem: { src: '', alt: '' }
    }
  },
  methods: {
    obterTopico: function () {
      this.imagem = {
        src: ImageUtils.obterUrlCompletaImagem(`${this.ementaCurso.topico_escolhido.url}`, 'topicos-imagem/'),
        alt: this.ementaCurso.topico_escolhido.titulo
      }
    }
  },
  mounted () {
    this.obterTopico()
  },
  watch: {
    ementaCurso: function () {
      this.obterTopico()
    }
  }
}
</script>

<style scoped>

</style>
